import { proxy, snapshot } from 'valtio'

export interface DataState {
  data: {
    firstName: string
    lastName: string
    email: string
    companySlug: string
    landingPageToken: string
  }
}

const state = proxy<DataState>({
  data: {
    firstName: '',
    lastName: '',
    email: '',
    companySlug: '',
    landingPageToken: '',
  },
})

const setAnonymousUserData = (payload: DataState) => {
  state.data = payload.data
}

export const useAnonymousUserData = () => {
  const snap = snapshot(state)

  return {
    anonymousUserData: snap.data,
    setAnonymousUserData,
  }
}
